import { render, staticRenderFns } from "./InfoBankAccountTeacher.vue?vue&type=template&id=47ef5a34"
import script from "./InfoBankAccountTeacher.vue?vue&type=script&lang=js"
export * from "./InfoBankAccountTeacher.vue?vue&type=script&lang=js"
import style0 from "./InfoBankAccountTeacher.vue?vue&type=style&index=0&id=47ef5a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports